import React from 'react';
import { useSelector } from 'react-redux';
import { Box, ContentBlock } from 'braid-design-system';

import Logo from './components/Logo/Logo';
import Menu from './components/Menu/Menu';
import MenuDrawer from './components/MenuDrawer/MenuDrawer';

import useMediaQuery from '../../../../hooks/useMediaQuery';

import { selectors as userSelectors } from '../../../../store/user';
import { selectors as routerSelectors } from '../../../../store/router';

import { Tags } from '../../../../types';

import * as styles from './Header.css';
import { UivBanner } from '@seek/uiv-banner';
import useAppConfig from 'src/hooks/useAppConfig';

function Header() {
  const { isMobile } = useMediaQuery();
  const { APP_NAME, APP_VERSION, BRANCH_NAME } = useAppConfig();
  const hasUserData = useSelector(userSelectors.getInitialDataStateSelector);
  const isValidRoute = useSelector(routerSelectors.isValidRouteSelector);

  if (!isValidRoute) {
    return null;
  }

  return (
    <>
      <Box
        component="header"
        position="fixed"
        zIndex="sticky"
        width="full"
        background="brand"
        boxShadow="small"
        style={{ transform: 'translate3d(0,0,0)' }}
        data-cy="talent-search-header"
      >
        <UivBanner
          applicationName={APP_NAME}
          branch={BRANCH_NAME}
          version={APP_VERSION}
        />
        <ContentBlock width="large">
          <Box
            data-cy={Tags.Data.Logo}
            className={styles.space}
            paddingX="medium"
            display="flex"
            justifyContent="spaceBetween"
          >
            <Logo />
            {hasUserData && <>{isMobile ? <MenuDrawer /> : <Menu />}</>}
          </Box>
        </ContentBlock>
      </Box>
      <Box className={styles.space} />
    </>
  );
}

export default Header;
